<template>
  <footer class="bg-pruta-green">

    <div class="flex flex-col w-full sm:max-w-7xl pt-10 pb-4 mx-auto">
      <div class="flex sm:flex-row px-6 sm:px-8 gap-8 sm:gap-0 flex-col-reverse">
        <div class="w-full sm:w-1/3 flex flex-col gap-4 sm:gap-4 items-start mt-8 sm:mt-0">
          <div class="flex items-start justify-between gap-8 sm:gap-2 sm:flex-col">
            <img src="/images/pruta-logo-white.svg" alt="Pruta Logo" class="h-6 sm:h-8 w-auto sm:mr-2" />
            <h2 class="text-brand text-sm sm:text-lg leading-tight text-left "> Helps homeowners and agents connect through transparent property auctions.</h2>
          </div>
          <p class="text-gray-light text-xs leading-relaxed text-center sm:text-left">Level 3, 223 Liverpool Street, Darlinghurst NSW 2010 AUSTRALIA</p>
        </div>
        <div class="flex-1 flex">
          <nav class="w-full sm:ml-auto sm:w-auto">
            <ul class="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-10">
              <li>
                <h3 class="text-sm sm:text-base text-brand mb-3">Menu</h3>
                <ul class="space-y-2 text-sm ">
                  <li><a href="#" class="text-gray-light hover:text-brand">Home</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">How It Works</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">FAQ</a></li>
                </ul>
              </li>
              <li>
                <h3 class="text-sm sm:text-base text-brand mb-3">Support</h3>
                <ul class="space-y-2 text-sm">
                  <li><a href="#" class="text-gray-light hover:text-brand">Help Centre</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">Contact Us</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">Report a Problem</a></li>

                </ul>
              </li>
              <li>
                <h3 class="text-sm sm:text-base text-brand mb-3">Social</h3>
                <ul class="space-y-2 text-sm">
                  <li><a href="#" class="text-gray-light hover:text-brand">Facebook</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">Twitter</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">Instagram</a></li>
                </ul>
              </li>
              <li>
                <h3 class="text-sm sm:text-base text-brand mb-3">Legal</h3>
                <ul class="space-y-2 text-sm">
                   <li><a href="#" class="text-gray-light hover:text-brand">Terms of Use</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">Privacy Policy</a></li>
                  <li><a href="#" class="text-gray-light hover:text-brand">Cookie Policy</a></li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>

      </div>
    </div>
    <div class="bg-[#0B3132] py-4 mt-4 gap-10 w-full text-gray-light flex items-center justify-center space-x-1 mx-auto text-paragraph-smaller-regular">
      <p class="text-sm">© 2025 Pruta® Inc. All rights reserved. </p>
    </div>
  </footer>
</template>

<script setup lang="ts">
</script>
